<template>
	<div class="myHeader">
		<div class="inner-box pdt20 pdb20 flex">
			<img src="../assets/images/msh22.png" width="140px" height="45px" />
			<el-menu :default-active="activeIndex" :default-openeds="openeds" class="el-menu-demo menue"
				mode="horizontal" text-color="#454754" active-text-color="#ff8500">
				<el-menu-item index='1' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/home" tag="div">首页</router-link>
				</el-menu-item>
				<el-menu-item index='2' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/Outsourcing" tag="div">谋生活外包</router-link>
				</el-menu-item>
				<el-menu-item index='3' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/Makeliving" tag="div">谋生活灵工</router-link>
				</el-menu-item>
				<el-menu-item index='4' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/Recruiting" tag="div">谋生活招聘</router-link>
				</el-menu-item>
				<el-menu-item index='5' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/Seekinsurance" tag="div">谋生活零工保</router-link>
				</el-menu-item>
				<!-- <el-menu-item index='6' style="border-bottom-color: rgba(255, 133, 0, 0);">
					<router-link to="/Download" tag="div">下载</router-link>
				</el-menu-item> -->
			</el-menu>
			<div style="display: flex;align-items: center;">
				<div class="lx">
					<div style="margin: 0px 10px 0px 0px;"><i class="fa fa-phone"></i></div>
					<div>400 700 9161</div>
				</div>
				<div class="dl">
					<a href="https://company.61msh.com/#/login">企业登录</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "myHeader",
		data() {
			return {
				activeIndex: '1',
				openeds:[ "1" , "2" , "3" , "4" ,'5' ],// ,'6'
				navConfig: {
				  "home": "1",
				  "index":"1",
				  "Outsourcing": "2",
				  "Makeliving": "3",
				  "Recruiting": "4",
				  "Seekinsurance":"5",
				  // "Download":"6"
				}
			}
		},
		methods: {
			
		},
		mounted(){
		  var _this =this;
		  var href =window.location.href;
		  href=href.split("/")[href.split("/").length-1]
		  console.log(href);
		  _this.activeIndex=_this.navConfig[href]
		}
	}
</script>

<style scoped>
	.myHeader {
		width: 100%;
		/* height: 80px; */
		position: fixed;
		left: 0;
		top: 0;
		z-index: 10000;
		background-color: #fff;
		box-shadow: 0 4px 6px 0 #eff2f8;
	}

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pdb20 {
		padding-bottom: 15px;
	}

	.pdt20 {
		padding-top: 15px;

	}



	/* .menue {
		margin-left: 62px;
		display: flex;
		align-items: center;
		margin-right: 200px;
	} */
	.el-menu-item {
		color: #454754;
		position: relative;
		font-size: 16px;
	}

	.el-menu.el-menu--horizontal,
	.el-menu--horizontal>.el-menu-item.is-active {
		border: none;
	}

	.el-menu--horizontal>.el-menu-item.is-active::before {
		width: 0;
		height: 0;
		content: "";
		border: 5px solid transparent;
		border-top-color: transparent;
		border-top-color: #ff8500;
		position: absolute;
		bottom: -15px;
		left: 50%;
		margin-left: -5px;
		z-index: 999;
	}

	.el-menu--horizontal>.el-menu-item {
		height: auto;
		line-height: initial;
	}

	.lx {
		display: flex;
		align-items: center;
		border: 1px solid #ff8500;
		color: #ff8500;
		border-radius: 30px;
		padding: 8px 20px;
	}
	.lx:hover{
		background-color: #FF8500;
		color: #FFFFFF;
	}
	.dl{
		margin-left: 10px;
		text-align: center;
		display: block;
		border: 1px solid #ff8500;
		border-radius: 30px;
		padding: 7px 25px;
	}
	.dl a{
		font-size: 16px;
		color: #FF8500;
	}
	.dl:hover{
		background-color: #FF8500;
	}
	.dl:hover a,a:hover,a:active{
		color:#fff
	}
</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue